// API Configuration
let runtimeConfig = null;

// Config'i public klasöründeki config.json'dan yükle
export const loadConfig = async () => {
    try {
        const response = await fetch('/HasarIhbar/ui/config.json');
        if (response.ok) {
            runtimeConfig = await response.json();
            console.log('Runtime config loaded:', runtimeConfig);
        } else {
            console.warn('config.json not found, using environment variables or default values');
            runtimeConfig = {
                apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://localhost:7047/api'
            };
        }
    } catch (error) {
        console.error('Error loading config:', error);
        runtimeConfig = {
            apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://localhost:7045/api'
        };
    }
    return runtimeConfig;
};

// Config nesnesini döndür
const getConfig = () => {
    if (!runtimeConfig) {
        // Config henüz yüklenmediyse environment variable veya default değerleri kullan
        return {
            apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://localhost:7050/api'
        };
    }
    return runtimeConfig;
};



export default getConfig;
